module.exports = __webpack_public_path__ + "img/78.2.TN.467b3b8a.png";